export default {
  en: "Angielski",
  pl: "Polski",
  ae: "Arabski",
}
